import React from "react"

const AppointmentSlotSelector = ({ availableSlots, selectedSlot, onSelectSlot, selectedDate, emptyMessage }) => {
  const visibleSlots = availableSlots || []

  return (
    <div className="border rounded p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-0">Available Slots</h6>
        <small className="text-muted">{selectedDate ? new Date(selectedDate).toLocaleDateString() : "Select a date"}</small>
      </div>
      <div className="d-flex flex-wrap gap-2">
        {visibleSlots.length ? visibleSlots.map(slot => {
          const slotId = slot.slotId || slot._id || slot.id
          const slotDate = slot.date || slot.day || slot.availableDate
          const slotTime = slot.time || slot.startTime
          const slotStatus = slot.status || slot.availabilityStatus
          const isSelected = selectedSlot?.slotId === slotId || selectedSlot?._id === slotId || selectedSlot?.id === slotId
          const isUnavailable =
            slot.available === false ||
            (slotStatus && slotStatus.toString().toUpperCase() !== "AVAILABLE")
          return (
            <button
              key={slotId || `${slotDate}-${slotTime}`}
              type="button"
              className={`btn btn-sm ${isSelected ? "btn-primary" : "btn-outline-primary"}`}
              disabled={isUnavailable}
              onClick={() => onSelectSlot(slot)}
              title={isUnavailable ? "Unavailable" : "Select slot"}
            >
              {slotTime || "Slot"}
              {isUnavailable ? " (Unavailable)" : ""}
            </button>
          )
        }) : (
          <div className="text-muted">{emptyMessage || "No slots found."}</div>
        )}
      </div>
    </div>
  )
}

export default AppointmentSlotSelector
